import React, { ReactNode } from "react";
import DeviceContext from "../../../../service/indentifyDevice";
import { AObMfReq, AObMfHist, AObMfSip } from "../../../../service/orderBook/obApiService";

import { mfNav } from "../../obConstants";
import { Idevice } from "../../../../types/device";
import moment from "moment";
import NoDataContainer from "../../../../generic/noDataContainer";
import { SDevWiseStateComp } from "../obDeviceComp";

import ObMutualFund from "../../instruments/secondaryMarket/obMutualFund";
import ObMutualFundMob from "../../instruments/secondaryMarket/obMutualFundMob";
import Loader, { SLoader } from "../../../../generic/loader";
import { IListObj } from "../../../../types/genericTypes";

export interface IObMfContainerProps {
	match?: any;
}

const ObMfContainer: React.FC<IObMfContainerProps> = (props) => {
	const [hidepgNav, setHidePageNav] = React.useState<boolean>(false);
	const [instrument, setInstrument] = React.useState<ReactNode>(<></>);
	let filteredData: Array<{}> = [];
	const obLoader = (
		<div className="loaderWrap">
			<Loader size={20} color="blue" />
		</div>
	);

	// priNavOptions do not change (no need of state)
	const priNavOptions: Array<IListObj> = [
		{ value: "today", display: "Today's orders", href: mfNav.today },
		{ value: "history", display: "History", href: mfNav.history },
		{ value: "sip", display: "SIP Orders", href: mfNav.sip }
	];

	//url params controlled vars
	let activeSecNav: string = props.match.params.secNav.toLowerCase();
	let history: boolean = props.match.params.pageNav === priNavOptions[1].value ? true : false;
	let sip: boolean = props.match.params.pageNav === priNavOptions[2].value ? true : false;
	let isLoading: boolean = false;

	const setNHandle = (data: any) => {
		filteredData = data;
		handleSecNav(activeSecNav);
	};

	const mfOrderBookRes = (res: any) => {
		res.data ? setNHandle(res.data.ordLst) : setNHandle([]);
	};

	const mfOrderBookHistRes = (res: any) => {
		if (history) {
			isLoading = false;

			res.data ? setNHandle(res.data.ordLst) : setNHandle([]);
		}
	};

	const mfSipOrderBook = (res: any) => {
		if (sip) {
			res.data ? setNHandle(res.data.sipOrdLst) : setNHandle([]);
		}
	};

	//handle page navigation today's, history data
	const handlePageNav = (selectVal: string) => {
		switch (selectVal) {
			case "history":
				history = true;
				sip = false;
				isLoading = true;

				setNHandle([]);
				break;
			case "today":
				history = false;
				sip = false;
				setInstrument(obLoader);
				AObMfReq(mfOrderBookRes);
				break;
			case "sip":
				history = false;
				sip = true;
				setInstrument(obLoader);
				AObMfSip(mfSipOrderBook);
				break;
			default:
				console.log("not found");
				break;
		}
	};

	const getDates = (fromDt: Date, toDate: Date) => {
		if (history) {
			AObMfHist(mfOrderBookHistRes, moment(fromDt).format("DD/MM/YYYY"), moment(toDate).format("DD/MM/YYYY"));
		}
	};

	const handleDevice: Idevice = DeviceContext();
	//toggler to show and hide the page navigation in the events of any operation
	const hidePageNav = (toggle: boolean) => {
		setHidePageNav(toggle);
	};

	//handles section navigation based on page navigation
	const handleSecNav = (nav: string) => {
		let inst: ReactNode = <></>,
			nodataNode: ReactNode = <></>;

		//show no data container
		if (filteredData.length === 0) {
			nodataNode = (
				<NoDataContainer
					txtHeading={history || sip ? "" : `You haven’t placed any Mutual Fund orders today`}
					txtSubHeading={
						!history && !sip
							? "Investing today can help you grow your wealth"
							: sip
							? "There are no SIP orders placed by you" // message if there are no SIP orders
							: "There are no orders for the selected date range and asset class"
					}
					btnDet={{
						txt: history ? "Today's Orders" : "Place Order",
						href: history ? "today" : "temp",
						clickHandler: () => {},
						type: history ? "bLink" : "btn"
					}}
				/>
			);
		}
		if (history || filteredData.length !== 0) {
			inst =
				handleDevice.isDesktop || handleDevice.isTablet ? (
					<ObMutualFund
						data={filteredData}
						isHistory={history}
						getDates={getDates}
						isSip={sip}
						hidePageNav={hidePageNav}
						reRenderCall={handlePageNav}
					/>
				) : (
					<ObMutualFundMob
						data={filteredData}
						isHistory={history}
						getDates={getDates}
						isSip={sip}
						hidePageNav={hidePageNav}
						reRenderCall={handlePageNav}
					/>
				);
		}
		setInstrument(
			<>
				{inst}
				{((history && !isLoading) || !history) && nodataNode}
				{history && isLoading && SLoader(20, "blue")}
			</>
		);
	};
	React.useEffect(() => {
		handlePageNav(props.match.params.pageNav);
	}, [props.match.params.pageNav]);
	return <>{SDevWiseStateComp(priNavOptions, instrument, hidepgNav)}</>;
};

export default ObMfContainer;
